import { render, staticRenderFns } from "./QRCodeGenerator.vue?vue&type=template&id=5bc09ce7&"
import script from "./QRCodeGenerator.vue?vue&type=script&lang=js&"
export * from "./QRCodeGenerator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports